<template>
  <div>
    <div class="p404 bg-cercles">
      <div class="p404__content">
        <!-- <img
          class="p404__favicon"
          src="../assets/img/logos/favicon.svg"
          alt=""
        /> -->
        <h2 class="p404__title">{{ $t("emailPreferences.subscribeTitle") }}</h2>
        <p>
          {{ $t("emailPreferences.subscribeMessage") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubscribeBridge",
  metaInfo() {
    return {
      title: "Subscribed" + " | HelloBB",
      meta: [
        { name: "description", content: "You have been subscribed successfully." },
        { name: "robots", content: "noindex"},
      ]
    };
  },
  beforeCreate() {
    if (typeof window === "undefined") return;
    let langUrl = new URLSearchParams(window.location.search).get("lang") || "es";
    //get first two letters
    langUrl = langUrl.substring(0, 2).toLowerCase();
    console.log("langUrl", langUrl);
    if(langUrl == "fr") {
      this.lang = "fr-FR";
    } else if(langUrl == "it") {
      this.lang = "it-IT";
    }
    else if(langUrl == "en") {
      this.lang = "en-GB";
    }
    else {
      this.lang = "es";
    }
    this.$i18n.locale = this.lang;
  },
  mounted() {
    //get 'group' param query string
    const groupParam = this.$route.query.group;
    window.mixpanel.track("subscribe page visited", {
      group: groupParam || "unknown"
    });
    //get 'data' param query string
    const dataParam = this.$route.query.data;
    if (dataParam) {
      //use the API to unsubscribe (https://af-email-sender.azurewebsites.net/api/UnsubscribeEmailByKey?code=bYHYyhqxcTBD-89eP3ofwg0dDV_64iA4scb2Q0DiQroXAzFuo5X1ug==), with payload { data: dataParam }
      fetch("https://af-email-sender.azurewebsites.net/api/UnsubscribeEmailByKey?code=7nv0Fe-PYtELLlFxp36l-V0AHb_RHg6vJGNFiFjoA8y0AzFuWAnykg==", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ data: dataParam })
      }).then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
      }).catch(error => {
        console.error("There was a problem with the fetch operation:", error);
      });
    }
    else {
      console.log("No data param found in query string");
    }
  }
};
</script>

<style scoped>
p {
  font-size: 1.2rem;
  line-height: 1.5;
  max-width: 60%; /* O el ancho máximo que prefieras */
  margin: 0 auto; /* Esto centra el contenedor horizontalmente */
}

@media (max-width: 768px) {
  p {
    font-size: 1rem; /* Tamaño de fuente más pequeño para móviles */
    line-height: 1.4; /* Ajuste del interlineado para mejorar la legibilidad en pantallas pequeñas */
    max-width: 90%;
  }
}
</style>
